import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import classnames from 'classnames';
import Portal from 'react-minimalist-portal';
import modalManager from './modal-manager';
import noScroll from 'no-scroll';

import Icon from 'foundations/Icons/Icon';

import styles from './Modal.css';

class Modal extends Component {

  static propTypes = {
    animationDuration: PropTypes.number,
    children: PropTypes.node,
    closeOnEsc: PropTypes.bool,
    container: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    onOverlayClick: PropTypes.func,
    open: PropTypes.bool.isRequired,
    showCloseIcon: PropTypes.bool,
    customClasses: PropTypes.string,
    classNames: PropTypes.object
  }

  static defaultProps = {
    animationDuration: 500,
    closeOnEsc: true,
    showCloseIcon: true
  }

  constructor(props) {
    super(props);

    this.state = {
      open: props.open,
    };
  }

  componentDidMount() {
    if (this.props.open) {
      this.handleOpen();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.showPortal && !this.state.showPortal) {
      this.handleClose();
    } else if (!prevProps.open && this.props.open) {
      this.handleOpen();
    }
  }

  componentWillUnmount() {
    if (this.props.open) {
      this.handleClose();
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!prevState.showPortal && nextProps.open) {
      return {
        showPortal: true,
      };
    }

    return null;
  }

  handleOpen = () => {
    modalManager.add(this);
    noScroll.on();

    document.addEventListener('keydown', this.handleKeydown);
  };

  handleClose = () => {
    modalManager.remove(this);

    document.removeEventListener('keydown', this.handleKeydown);
  };

  handleCloseIconClick = event => {
    this.props.onClose(event);
  };

  handleKeydown = event => {
    if (event.code !== 'Escape' || !modalManager.isTopModal(this)) {
      return;
    }

    if (this.props.closeOnEsc) {
      this.props.onClose(event);
    }
  };

  handleExited = () => {
    noScroll.off();

    this.setState({ showPortal: false });
  };

  render() {
    const {
      open,
      animationDuration,
      children,
      showCloseIcon,
      customClasses
    } = this.props;

    const { showPortal } = this.state;

    if (!showPortal) { return null; }

    const modalClasses = classnames(
      styles.modalWrapper,
      customClasses
    );

    return (
      <Portal>
        <CSSTransition
          in={open}
          appear
          unmountOnExit
          classNames={{
            appear: styles.transitionEnter,
            appearActive: styles.transitionEnterActive,
            enter: styles.transitionEnter,
            enterActive: styles.transitionEnterActive,
            exit: styles.transitionExit,
            exitActive: styles.transitionExitActive,
          }}
          timeout={animationDuration}
          onExited={this.handleExited}
        >
          <div className={modalClasses}>
            { children }
            {showCloseIcon && (
              <button onClick={this.handleCloseIconClick} className={styles.closeButton}>
                <Icon icon={'close'} type={'20'}/>
              </button>
            )}
          </div>
        </CSSTransition>
      </Portal>
    );
  }

}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js